exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._21PFYQmPuhVxFC1tEjKDUe{text-align:left;display:flex;width:260px}._21PFYQmPuhVxFC1tEjKDUe ._1AUiiZ34C1xkpADd9pUvwi{line-height:0;padding:15px}._21PFYQmPuhVxFC1tEjKDUe ._1AUiiZ34C1xkpADd9pUvwi img{height:50px;width:50px;border-radius:50%;box-shadow:1px 1px 4px 0 rgba(0,0,0,0.1)}._21PFYQmPuhVxFC1tEjKDUe ._3dOf4W_a5zF8TkK5CU8qxl{font-weight:500;color:#424242;font-size:14px}._21PFYQmPuhVxFC1tEjKDUe .j6F0ovvrvkH1VVyDeLBql{color:#757575;font-size:14px}._3F5b4k7fmq0cSIleDCi0d1{padding-top:15px}._50hhfmfn7lRVuuJP2jutJ{padding:20px 20px}\n", ""]);

// Exports
exports.locals = {
	"UserCard": "_21PFYQmPuhVxFC1tEjKDUe",
	"profileImg": "_1AUiiZ34C1xkpADd9pUvwi",
	"username": "_3dOf4W_a5zF8TkK5CU8qxl",
	"location": "j6F0ovvrvkH1VVyDeLBql",
	"UserContent": "_3F5b4k7fmq0cSIleDCi0d1",
	"private": "_50hhfmfn7lRVuuJP2jutJ"
};